
    <a [title]="text.export"
       class="button export-bcf-button"
       download
       [attr.href]="exportLink">
      <op-icon icon-classes="button--icon icon-export"></op-icon>
      <span class="button--text"> {{text.export}} </span>
    </a>
  